import React, { Fragment, useDebugValue, useEffect, useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Loading from '../../Common/Loading';
import Switch from "react-switch";
import { addAgentToSyncList, addKBToSyncList, fetchImportAssets, getAgentByApiCommon, getDarkThemeColor, getEncodeData, getKnowledgeByApiCommon, getSessionValue, handelCommonChangeAgent, handleCommonRemoveAgent, handleErrorResponse, renderSelectableList, setLicenseInfo, showToast, syncProviderDetails, translateContent,addNumberToSyncList, getPhoneNumberByApiCommon, getPopupFromDemoAccount,getImportInfoByApiCommon, addImportInfoToSyncList } from "../../Common/Appcommon";

const ImportModel = (props) => {
    let {type, isModelOpen, toggleModal, title ,showButtonLoader = undefined} = props;
    const [currentList, setCurrentList] = useState([]); 
    const [optionList, setOptionList] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [isIMModalOpen, setIsModalOpen] = useState(false);
    const [preSelectedList, setPreSelectedList] = useState([]);
    const [errorMsg, setErrorMsg] = useState();
    const [showButtonLoading, setShowButtonLoading] = useState(false);
    const [inputData,setInputData] = useState({});

    useEffect(async () => {
        showButtonLoader?.(true);
        await fetchProviderData();
        setTimeout(async () => {
            await fetchAssets();
            showButtonLoader?.(false);
        }, 100);
    }, []);

    const importModalOpenActions = (isRefresh = false) => {
        toggleModal(isRefresh);
        setIsModalOpen(!isIMModalOpen);
    }

    const fetchProviderData = async () => {
        try {
            let appid = getSessionValue('subAccountAppid');
            let provider = getSessionValue("agent_provider_name");
            let apiDetails = getSessionValue(provider + "_api_keys");
            // let encodedData = getEncodeData(apiDetails,appid);
            if (type === "agent") {
                const Agentresponse = await getImportInfoByApiCommon(provider,type, apiDetails, appid, true);
                const Agentdata = Agentresponse.data[0];
                setOptionList(Agentdata);
            } else if (type === "knowledge") {
                const KBresponse = await getImportInfoByApiCommon(provider,type, apiDetails, appid, true);
                const KBdata = KBresponse.data[0];
                setOptionList(KBdata);
            }else if (type === "numbers_sync") {
                const numberResponse = await getImportInfoByApiCommon(provider,type, apiDetails, appid, true);
                const numberData = numberResponse.data[0];
                setOptionList(numberData);
            }
            
        } catch (error) {
            console.error("Error fetching provider data:", error);
        }
    }

    const fetchAssets = async () => {
        let appid = getSessionValue('subAccountAppid');
        let response = await fetchImportAssets(appid, type);
        if(response.issuccess){
            let list = response.list;
            let aData = response.data;
            if(list.length > 0){
                // setSelectedList(list);
                let preSelectedValue = [];
                let newSList = [];
                list.map((variant, index) => {
                    preSelectedValue.push(variant.value.value);
                    let newSelected = variant.value;
                    newSList.push(newSelected);
                });
                setPreSelectedList(newSList);
                let newOptions = [];
                if(typeof optionList !== undefined && optionList.length > 0 ){
                    for(let oi = 0; oi < optionList.length; oi++){
                        if(!preSelectedValue.includes(optionList[oi].value)){
                            newOptions.push(optionList[oi]);
                        }
                    }
                    setOptionList(newOptions);
                }
                if(type === "agent" && aData.length > 2){
                    let addonConfig = aData[3];
                    if(addonConfig !== "" && addonConfig !== null){
                        setInputData(JSON.parse(addonConfig));
                    }
                }
            } else {
                // onAddMoreVariants(1,type);
            }
            onAddMoreVariants(1,type);
            setIsModalOpen(true);
        } else {
            showToast(translateContent("vm.import.no.asset.found",{asset: title}))
        }
    }

    const handleListChange = async (selectedOption, index) => {
        const [updatedList, updatedSyncAgents, updatedAgents]  = await handelCommonChangeAgent(selectedOption, index, selectedList, optionList ,currentList)
        setSelectedList(updatedList);
        setOptionList(updatedAgents);
        setCurrentList(updatedSyncAgents);
    };
    
    const removeVariant = async (index) => {
        const [updatedList, updatedSyncAgents, updatedCurrentAgents] = await handleCommonRemoveAgent(index, selectedList, optionList);
        setSelectedList(updatedList);
        setOptionList(updatedCurrentAgents);
        setCurrentList(updatedSyncAgents);
    };

    const onAddMoreVariants = (variationCount, name) => {
        const newList = [
            ...selectedList,
            ...Array.from({ length: variationCount }, () => ({ value: null }))
        ];
        setSelectedList(newList);
    };

    const onImportAssets = async () => {
        if (getPopupFromDemoAccount()) {
            return;
        }
        setShowButtonLoading(true);
        if(currentList.length === 0) {
            setErrorMsg(translateContent("vm.no.asset.choosed"));
            setShowButtonLoading(false);
            return;
        } else {
            setErrorMsg("");
        }
        // let apiDetails = getSessionValue("agent_api_details");
        let appid = getSessionValue('subAccountAppid');
        let provider = getSessionValue("agent_provider_name");
        let providerData = getSessionValue(provider + "_api_keys");
        let response ;
        const merged = [
            ...currentList,
            ...preSelectedList.filter(
                pre => !currentList.some(cur => cur.value === pre.value)
            )
        ];
        if(type === 'agent'){
            response = await addImportInfoToSyncList(appid,merged,provider,providerData,false,type, inputData, true);
        } else if(type === 'knowledge'){
            response = await addImportInfoToSyncList(appid,merged,provider,providerData,false,type, [],true);
        }else if(type === 'numbers_sync'){
            response = await addImportInfoToSyncList(appid,merged,provider,providerData,false,type,[], true);
        }
        if(!response.issuccess){
            let errorMessage = translateContent("vm.update.api.sync.failed",{label: title});
            handleErrorResponse(errorMessage); 
            setShowButtonLoading(false);               
        } else {
            let isSyncSuccess = await syncProviderDetails(appid, type, inputData);
            if(isSyncSuccess){
                importModalOpenActions(true);
            }
        }
    }

    const handleInputChange = (e,name, type) =>{
        let tmpInputData = { ...inputData };
        tmpInputData[name] = e;
        setInputData(tmpInputData);
    }

    return (
        <Modal isOpen={isIMModalOpen} contentClassName="">
            <ModalHeader toggle={importModalOpenActions}>{title}</ModalHeader>
            <ModalBody>
                <div className="">
                    <div>
                        {renderSelectableList(
                            selectedList,
                            optionList,
                            handleListChange,
                            removeVariant,
                            onAddMoreVariants,
                            'agent',
                            11,
                        )}
                    </div>
                    {errorMsg && <em className={`error invalid-feedback`}>{errorMsg}</em>}
                </div>
                {type === "agent" && 
                    <div className="agent-advance-config mt-2">
                        <div className="d-flex align-center">
                            <Switch 
                                height={20} 
                                width={40} 
                                onColor={getDarkThemeColor()}
                                onChange={(e) => handleInputChange(e, "import_phonenumbers", 'Switch')}
                                name={"import_phonenumbers"}
                                checked={inputData["import_phonenumbers"] || false}
                            />
                            <span className="pl-2">Import all associated phone numbers</span>
                        </div>
                        <div className="d-flex align-center mt-2">
                            <Switch 
                                height={20} 
                                width={40} 
                                onColor={getDarkThemeColor()}
                                onChange={(e) => handleInputChange(e, "import_calllogs", 'Switch')}
                                name={"import_calllogs"}
                                checked={inputData["import_calllogs"] || false}
                            />
                            <span className="pl-2">Import all existing call logs</span>
                        </div>
                    </div>
                }
            </ModalBody>
            <ModalFooter>
                <Loading showLoader={showButtonLoading} mainContent={
                    <Fragment>
                        <Button onClick={(e) => {onImportAssets(e)}} className='d-flex flex-center align-center theme-bg-g'>
                            Import
                        </Button>
                    </Fragment>
                } />
            </ModalFooter>
        </Modal>

    )
}

export default ImportModel;